import type { WShopRecomendedProductsTranslations } from "./pl";

export const de: WShopRecomendedProductsTranslations = {
  title: "Empfohlene Produkte",
  showAll: "Alle anzeigen",
  noProducts: "Keine empfohlenen Produkte.",
};
